import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 保存类型
 */
class SaveType extends UltMeta {
    SAVE_TO_DRAFT = new Meta(1, "保存为草稿");
    SAVE_AND_COMMIT = new Meta(2, "保存并提交");
}

export const DEAL_OUTBOUND_SAVE_TYPE = new SaveType();

/**
 * 进销存 入库管理状态
 */
class State extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_OUTBOUND = new Meta(2, "待出库");
    REJECTED = new Meta(3, "已驳回");
    OUT_BOUNDED = new Meta(4, "已出库");
    INVALIDATED = new Meta(5, "已作废");
}

export const DEAL_OUTBOUND_STATE = new State();

/**
 * 入库类型
 */
class InboundType extends UltMeta {
    SELLER_OUTBOUND = new Meta(1, "销售出库", 7);
    ALLOT_OUTBOUND = new Meta(2, "调拨出库", 8);
    USE_OUTBOUND = new Meta(3, "领用出库", 9);
    INVENTORY_LOSS_OUTBOUND = new Meta(4, "盘亏出库", 10);
    REJECT_GOODS_OUTBOUND = new Meta(5, "退货出库", 11);
    SCRAP_OUTBOUND = new Meta(6, "报废出库", 12);
    OTHER_OUTBOUND = new Meta(7, "其他出库", 13);
}

export const DEAL_OUTBOUND_TYPE = new InboundType();
